import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { CurrenciesService } from "src/app/api/currencies.service";
import { Currency } from "src/app/models/currency";

@Component({
  selector: "bitoasis-features",
  templateUrl: "./bitoasis-features.component.html",
  styleUrls: ["./bitoasis-features.component.scss"],
})
export class BitoasisFeaturesComponent implements OnInit {
  active: 0 | 1 | 2 | 3 = 0;

  constructor(private currenciesService: CurrenciesService) {}

  ngOnInit() {}

  public currencies$: Observable<Currency[]> =
    this.currenciesService.getCrypto();
}
